/**
 * @generated SignedSource<<819dbb34df2fa5485c870dcd1849c265>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type CrmListTypeEnum = "CONTACT";
export type PostStatusEnum = "ACF_DISABLED" | "AUTO_DRAFT" | "DRAFT" | "FUTURE" | "HIDDEN" | "HIDDEN_B_S" | "INHERIT" | "PENDING" | "PRIVATE" | "PUBLISH" | "REQUEST_COMPLETED" | "REQUEST_CONFIRMED" | "REQUEST_FAILED" | "REQUEST_PENDING" | "TRASH";
export type StatusUiPermissionEnum = "PUBLIC" | "RESTRICTED";
import { FragmentRefs } from "relay-runtime";
export type CrmList_Basic_Fragment$data = {
  readonly author: {
    readonly node: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly slug: string | null | undefined;
      readonly username: string | null | undefined;
    };
  } | null | undefined;
  readonly content: string | null | undefined;
  readonly created: string | null | undefined;
  readonly id: string;
  readonly status: PostStatusEnum | null | undefined;
  readonly statusSettings: {
    readonly approved: {
      readonly id: string | null | undefined;
      readonly timestamp: string | null | undefined;
      readonly user: {
        readonly name: string | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly stateWhenApproved: {
      readonly status: PostStatusEnum | null | undefined;
      readonly uiPermission: {
        readonly type: StatusUiPermissionEnum | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly status: PostStatusEnum | null | undefined;
    readonly uiPermission: {
      readonly type: StatusUiPermissionEnum | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly type: CrmListTypeEnum | null | undefined;
  readonly " $fragmentType": "CrmList_Basic_Fragment";
};
export type CrmList_Basic_Fragment$key = {
  readonly " $data"?: CrmList_Basic_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CrmList_Basic_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "UIPermission",
  "kind": "LinkedField",
  "name": "uiPermission",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CrmList_Basic_Fragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "StatusSettings",
      "kind": "LinkedField",
      "name": "statusSettings",
      "plural": false,
      "selections": [
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "StateWhenApproved",
          "kind": "LinkedField",
          "name": "stateWhenApproved",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            (v3/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ApprovedState",
          "kind": "LinkedField",
          "name": "approved",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "timestamp",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "User",
              "kind": "LinkedField",
              "name": "user",
              "plural": false,
              "selections": [
                (v4/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NodeWizAuthorToUserConnectionEdge",
      "kind": "LinkedField",
      "name": "author",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v4/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "username",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "slug",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    }
  ],
  "type": "CrmList",
  "abstractKey": null
};
})();

(node as any).hash = "a0c6d771dbae75f2db6b23daf1efc192";

export default node;
